
import { css } from '@emotion/react';
import ClickableContainer from 'components/clickable-container';
import { useContext, useState } from 'react';
import { AngularContext } from 'react-app';
import t from 'react-translate';
import { AlertMessageProps } from 'redux/schemas/app/alert-message';
import { doubleSpacing, halfSpacing, quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { textMediumLineHeight } from 'styles/global_defaults/fonts';
import AlertMessage from './alert-message';

const AlertCloningMessage = (props: AlertMessageProps & { removeAlertMessage: Function }) => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const { customElement, ...alertProps } = props;
  const { newClone } = customElement.props;

  const customAlertStyles = css`
    &.alert-message {
      .flash-content {
        padding-top: ${halfSpacing}px;
        padding-bottom: ${halfSpacing}px;
      }
      .flash-message-container, .flash-content-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .flash-icon {
        font-size: ${textMediumLineHeight}px;
      }
    }
  `;

  const AlertMessageExtraElements = () => {
    const [hasBeenCopied, setHasBeenCopied] = useState(false);
    const newCourseURL = newClone.isJourney
      ? $state.href('learning-journey-home', { catalogId: newClone.nickname })
      : $state.href('course-home', { catalogId: newClone.nickname });
    const style = css`
      padding-top: ${quarterSpacing}px;
      .copy-button {
        padding-right: ${doubleSpacing}px;
        height: ${standardSpacing}px;
      }
      .open-link {
        height: ${standardSpacing}px;
      }
      .icon {
        padding-right: ${quarterSpacing}px;
      }
    `;
    const closeMessage = () => {
      setTimeout(() => {
        props.removeAlertMessage?.();
      }, 1000);
    };
    return (
      <div className='extra-options d-flex' css={style}>
        <ClickableContainer
          className={`copy-button d-flex align-items-center ${hasBeenCopied ? 'text-success' : 'text-primary'}`}
          onClick={() => {
            navigator.clipboard.writeText(`${window.location.host}/${newCourseURL}`);
            setHasBeenCopied(true);
            closeMessage();
          }}
        >
          <i className={`icon icon-${hasBeenCopied ? 'check' : 'duplicate'}`} />
          <span className='font-weight-bolder'>
            {
              hasBeenCopied
                ? t.COURSES.CLONE.CLONE_FINISHED.URL_COPIED()
                : t.COURSES.CLONE.CLONE_FINISHED.COPY_COURSE_URL()
            }
          </span>
        </ClickableContainer>
        <a
          href={newCourseURL}
          target='_blank'
          rel='noopener noreferrer'
          className='open-link d-flex align-items-center text-primary'
          onClick={() => closeMessage()}
        >
          <i className='icon icon-open-external' />
          <span className='font-weight-bolder'>
            {t.COURSES.CLONE.CLONE_FINISHED.OPEN_COURSE()}
          </span>
        </a>
      </div>
    );
  };

  const CustomMessage = () => (
    <span>
      {t.COURSES.CLONE.CLONE_FINISHED.SUCCESS(newClone.newName)}
    </span>
  );

  return <AlertMessage {...alertProps} extraContent={<AlertMessageExtraElements />} customMessage={<CustomMessage />} extraStyles={customAlertStyles} />;
};

export default AlertCloningMessage;
